import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LanguageService } from '@igo2/core/language';

@Component({
    selector: 'app-pop-up-gdf',
    templateUrl: './pop-up-gdf.component.html',
    styleUrls: ['./pop-up-gdf.component.scss'],
    imports: [
        MatDialogModule,
        MatButtonModule
    ]
})
export class PopUpGdfComponent {
  languageService = inject(LanguageService);

  constructor(public dialogRef: MatDialogRef<PopUpGdfComponent>) { }

  information = this.languageService.translate.instant('sigt.integration.rechercheGdf.form.serviceGdf.information');
  questionConserverResultatPrecedent = this.languageService.translate.instant('sigt.integration.rechercheGdf.form.serviceGdf.questionConserverResultatPrecedent');
  oui = this.languageService.translate.instant('sigt.integration.rechercheGdf.form.serviceGdf.oui');
  non = this.languageService.translate.instant('sigt.integration.rechercheGdf.form.serviceGdf.non');
}
